module.exports = __webpack_public_path__ + "img/glogo213.58dae65e.png";